/**
 * Human labels for Nightwork / Rest-Day Work activity logs and list banners.
 *
 * Trade leaders, HODs, and HR scan these as a verb ("what changed?"), never as
 * a modification_type slug. Unknown keys must not fall back to snake_case.
 */

const HR_ACTION_SHORT_LABELS = {
  hr_add_workers: 'Workers added',
  hr_remove_workers: 'Workers removed',
  hr_swap_worker: 'Worker swapped',
  hr_add_safety: 'Safety personnel added',
  hr_remove_safety: 'Safety personnel removed',
  hr_swap_safety: 'Safety personnel swapped',
  hr_adjust_dates: 'Dates adjusted',
  hr_adjust_times: 'Times adjusted',
  hr_change_project: 'Project changed',
  hr_cancel: 'Request cancelled',
};

export const MODIFICATION_LABELS = {
  submitted: 'Request submitted for approval',
  deputy_hod_approved: 'Approved by Deputy HOD',
  deputy_hod_rejected: 'Rejected by Deputy HOD',
  hod_approved: 'Approved by HOD',
  hod_rejected: 'Rejected by HOD',
  approved_deputy_hod: 'Approved by Deputy HOD',
  rejected_deputy_hod: 'Rejected by Deputy HOD',
  approved_hod: 'Approved by HOD',
  rejected_hod: 'Rejected by HOD',
  cancelled: 'Request cancelled',
  amendment_created: 'Amendment draft created',
  amend_created: 'Amendment draft created',
  amendment_submitted: 'Amendment submitted for approval',
  amendment_approved: 'Amendment approved & applied',
  amendment_rejected: 'Amendment rejected',
  frozen: 'Request frozen (amendment pending)',
  superseded: 'Superseded by amendment',
  worker_deactivated: 'Worker auto-deactivated',
  edited_pending: 'Request edited while pending approval',
  returned_for_amendment: 'Returned for amendment',
  ...Object.fromEntries(
    Object.entries(HR_ACTION_SHORT_LABELS).map(([key, label]) => [key, `HR: ${label}`])
  ),
};

export const formatHrActionBannerTitle = (type) => {
  const short = HR_ACTION_SHORT_LABELS[type];
  if (short) return `HR: ${short}`;
  return 'HR: Request updated';
};

export const formatModificationType = (type) => {
  if (!type) return 'Request updated';
  if (MODIFICATION_LABELS[type]) return MODIFICATION_LABELS[type];
  if (String(type).startsWith('hr_')) return 'HR: Request updated';
  return 'Request updated';
};
